
import AccordionsComponent from '@components/Accordions';

import { Accordion } from '@/types';

type Props = {
  accordions: Accordion[];
  blocktitle?: string;
};

function Accordions(props: Props) {
  const { accordions, blocktitle } = props;

  return (
    <div className='streamfield accordions'>
      {blocktitle ? <h2 className='accordions__header'>{blocktitle}</h2> : null}

      <AccordionsComponent className='' accordions={accordions} />
    </div>
  );
}

export default Accordions;


